import nextId from "react-id-generator";

export const Data = {
  jobTitle: [],
  curriculum: [
    { id: nextId(), label: "CBSE", value: "CBSE" },
    { id: nextId(), label: "ICSE", value: "ICSE" },
    { id: nextId(), label: "IGCSE / CIE", value: "IGCSE / CIE" },
    { id: nextId(), label: "IB", value: "IB" },
    { id: nextId(), label: "International", value: "International" },
    { id: nextId(), label: "PU / +2", value: "PU / +2" },
    { id: nextId(), label: "Higher Education", value: "Higher Education" },
  ],
  role: [
    { id: nextId(), label: "Teacher", value: "Teacher" },
    { id: nextId(), label: "Senior Teacher", value: "Senior Teacher" },
    { id: nextId(), label: "Assistant Teacher", value: "Assistant Teacher" },
    { id: nextId(), label: "HoD", value: "HoD" },
    {
      id: nextId(),
      label: "Senior Leadership Team / SLT",
      value: "Senior Leadership Team / SLT",
    },
    { id: nextId(), label: "Principal", value: "Principal" },
    { id: nextId(), label: "Vice Principal", value: "Vice Principal" },
    { id: nextId(), label: "Coordinator", value: "Coordinator" },

    { id: nextId(), label: "Manager Admissions", value: "Manager Admissions" },
    {
      id: nextId(),
      label: "Admin / Administrator",
      value: "Admin / Administrator",
    },
    {
      id: nextId(),
      label: "Receptionist / Front Desk",
      value: "Receptionist / Front Desk",
    },
    {
      id: nextId(),
      label: "House Keep Head/ Incharge",
      value: "House Keep Head/ Incharge",
    },
  ],
  class: [
    {
      id: nextId(),
      label: "Early Year Programme / EYP",
      value: "Early Year Programme / EYP",
    },
    {
      id: nextId(),
      label: "Primary Year Programme / PYP",
      value: "Primary Year Programme / PYP",
    },
    {
      id: nextId(),
      label: "Middle Year Programme / PYP",
      value: "Middle Year Programme / PYP",
    },
    {
      id: nextId(),
      label: "Diploma Programme / DP",
      value: "Diploma Programme / DP",
    },
    {
      id: nextId(),
      label: "Early Years / Kindergarten / PPRT",
      value: "Early Years / Kindergarten / PPRT",
    },
    {
      id: nextId(),
      label: "Primary / Grade 1 - 4  / PRT",
      value: "Primary / Grade 1 - 4  / PRT",
    },
    {
      id: nextId(),
      label: "Middle / Grade 5 -7 / TGT",
      value: "Middle / Grade 5 -7 / TGT",
    },
    {
      id: nextId(),
      label: "High School / Grade 8 - 10 / PGT",
      value: "High School / Grade 8 - 10 / PGT",
    },
    {
      id: nextId(),
      label: "Senior Secondary School / Grade 11 & 12",
      value: "Senior Secondary School / Grade 11 & 12",
    },
    {
      id: nextId(),
      label: "Early Years / Kindergarten / PPRT",
      value: "Early Years / Kindergarten / PPRT",
    },
    {
      id: nextId(),
      label: "Primary / Grade 1 - 4  / PRT",
      value: "Primary / Grade 1 - 4  / PRT",
    },
    {
      id: nextId(),
      label: "Middle / Grade 5 -7 / TGT",
      value: "Middle / Grade 5 -7 / TGT",
    },
    {
      id: nextId(),
      label: "High School / Grade 8 - 10 / PGT",
      value: "High School / Grade 8 - 10 / PGT",
    },
    {
      id: nextId(),
      label: "Senior Secondary School / Grade 11 & 12",
      value: "Senior Secondary School / Grade 11 & 12",
    },
    {
      id: nextId(),
      label: "Early Years / Kindergarten / PPRT",
      value: "Early Years / Kindergarten / PPRT",
    },
    {
      id: nextId(),
      label: "Primary / Grade 1 - 4  / PRT",
      value: "Primary / Grade 1 - 4  / PRT",
    },
    {
      id: nextId(),
      label: "Middle / Grade 5 -7 / TGT",
      value: "Middle / Grade 5 -7 / TGT",
    },
    {
      id: nextId(),
      label: "High School / Grade 8 - 10 / PGT",
      value: "High School / Grade 8 - 10 / PGT",
    },
    {
      id: nextId(),
      label: "Senior Secondary School / Grade 11 & 12",
      value: "Senior Secondary School / Grade 11 & 12",
    },
  ],
  subjects: [
    { id: nextId(), label: "Biology", value: "Biology" },
    { id: nextId(), label: "Mathematics", value: "Mathematics" },
    { id: nextId(), label: "Dance", value: "Dance" },
    { id: nextId(), label: "HR", value: "HR" },
    { id: nextId(), label: "Preprimary", value: "Preprimary" },
    { id: nextId(), label: "Librarian", value: "Librarian" },
    {
      id: nextId(),
      label: "Content Developer - Mathematics",
      value: "Content Developer - Mathematics",
    },
    { id: nextId(), label: "Social Science", value: "Social Science" },
    {
      id: nextId(),
      label: "Business Development Manager / BDM",
      value: "Business Development Manager / BDM",
    },
    {
      id: nextId(),
      label: "Admission Counsellor",
      value: "Admission Counsellor",
    },
    { id: nextId(), label: "Hindi", value: "Hindi" },
    { id: nextId(), label: "Chemistry", value: "Chemistry" },
    { id: nextId(), label: "Kindergarten", value: "Kindergarten" },
    {
      id: nextId(),
      label: "Special Educator / SEN",
      value: "Special Educator / SEN",
    },
    {
      id: nextId(),
      label: "Special Educator Coordinator / SENCO",
      value: "Special Educator Coordinator / SENCO",
    },
    { id: nextId(), label: "Head of Boarding", value: "Head of Boarding" },
    {
      id: nextId(),
      label: "Executive Assistant / EA",
      value: "Executive Assistant / EA",
    },
    { id: nextId(), label: "Center Head", value: "Center Head" },
    { id: nextId(), label: "Vice Principal", value: "Vice Principal" },
    { id: nextId(), label: "Accountancy", value: "Accountancy" },
    { id: nextId(), label: "Music", value: "Music" },
    { id: nextId(), label: "History", value: "History" },
    { id: nextId(), label: "Physics ", value: "Physics " },
    { id: nextId(), label: "Sanskrit", value: "Sanskrit" },
    { id: nextId(), label: "Accountant", value: "Accountant" },
    { id: nextId(), label: "Content Developer", value: "Content Developer" },
    { id: nextId(), label: "IBDP", value: "IBDP" },
    {
      id: nextId(),
      label: "Front Office Assistant",
      value: "Front Office Assistant",
    },
    {
      id: nextId(),
      label: "Public Realtions Officer / PRO",
      value: "Public Realtions Officer / PRO",
    },
    {
      id: nextId(),
      label: "Design and Teachnology",
      value: "Design and Teachnology",
    },
    { id: nextId(), label: "Coordinator", value: "Coordinator" },
    { id: nextId(), label: "Kannada", value: "Kannada" },
    { id: nextId(), label: "Social Science", value: "Social Science" },
    { id: nextId(), label: "Science", value: "Science" },
    { id: nextId(), label: "Content Writer", value: "Content Writer" },
    { id: nextId(), label: "Content Management", value: "Content Management" },
    { id: nextId(), label: "Content Creation", value: "Content Creation" },
    { id: nextId(), label: "Content Editor", value: "Content Editor" },
    {
      id: nextId(),
      label: "Subject Matter Expert",
      value: "Subject Matter Expert",
    },
    {
      id: nextId(),
      label: "Subject Matter Expertise",
      value: "Subject Matter Expertise",
    },
    { id: nextId(), label: "SME Kannada", value: "SME Kannada" },
    { id: nextId(), label: "SME English", value: "SME English" },
    { id: nextId(), label: "SME Physics", value: "SME Physics" },
    { id: nextId(), label: "SME Chemistry", value: "SME Chemistry" },
    { id: nextId(), label: "SME Mathematics", value: "SME Mathematics" },
    { id: nextId(), label: "Physics SME", value: "Physics SME" },
    { id: nextId(), label: "Homeroom ", value: "Homeroom " },
    {
      id: nextId(),
      label: "Outreach Development Officer",
      value: "Outreach Development Officer",
    },
    { id: nextId(), label: "Teaching Hindi", value: "Teaching Hindi" },
    {
      id: nextId(),
      label: "Curriculam Developer",
      value: "Curriculam Developer",
    },
    { id: nextId(), label: "School Counselor", value: "School Counselor" },
    { id: nextId(), label: "Physical Education", value: "Physical Education" },
    { id: nextId(), label: "Economics", value: "Economics" },
    { id: nextId(), label: "Physcis", value: "Physcis" },
    {
      id: nextId(),
      label: "Curriculum Developer",
      value: "Curriculum Developer",
    },
    { id: nextId(), label: "Curriculum Head", value: "Curriculum Head" },
    {
      id: nextId(),
      label: "Content Development",
      value: "Content Development",
    },
    { id: nextId(), label: "Content Designer", value: "Content Designer" },
    {
      id: nextId(),
      label: "Educational Technology",
      value: "Educational Technology",
    },
    { id: nextId(), label: "French", value: "French" },
    { id: nextId(), label: "Spanish", value: "Spanish" },
    { id: nextId(), label: "College counselor", value: "College counselor" },
    { id: nextId(), label: "Counselor", value: "Counselor" },
    { id: nextId(), label: "ICT", value: "ICT" },
    { id: nextId(), label: "Career Counsellor", value: "Career Counsellor" },
    { id: nextId(), label: "Sociology Faculty", value: "Sociology Faculty" },
    {
      id: nextId(),
      label: "Kindergarten Coordinator",
      value: "Kindergarten Coordinator",
    },
    {
      id: nextId(),
      label: "Senior School Faculty - Design & Technology",
      value: "Senior School Faculty - Design & Technology",
    },
    {
      id: nextId(),
      label: "Design & Technology",
      value: "Design & Technology",
    },
    { id: nextId(), label: "Accounts Faculty", value: "Accounts Faculty" },
    { id: nextId(), label: "College Principal", value: "College Principal" },
    { id: nextId(), label: "PUC Principal", value: "PUC Principal" },
    { id: nextId(), label: "Lab Assistant", value: "Lab Assistant" },
    {
      id: nextId(),
      label: "Digital Marketing & Strategic Communication Specialist",
      value: "Digital Marketing & Strategic Communication Specialist",
    },
    { id: nextId(), label: "Psychology", value: "Psychology" },
    { id: nextId(), label: "IB Psychology", value: "IB Psychology" },
    { id: nextId(), label: "IBDP Psychology", value: "IBDP Psychology" },
    { id: nextId(), label: "Sr. Psychology", value: "Sr. Psychology" },
    { id: nextId(), label: "Psychology HOD", value: "Psychology HOD" },
    { id: nextId(), label: "Shadow", value: "Shadow" },
    { id: nextId(), label: "Theme", value: "Theme" },
    { id: nextId(), label: "Geography", value: "Geography" },
    { id: nextId(), label: "Sr. History", value: "Sr. History" },
    { id: nextId(), label: "IB Histrory", value: "IB Histrory" },
    { id: nextId(), label: "Drama", value: "Drama" },
    { id: nextId(), label: "Art and Craft", value: "Art and Craft" },
    { id: nextId(), label: "Yoga", value: "Yoga" },
    { id: nextId(), label: "Yoga Trainer", value: "Yoga Trainer" },
    { id: nextId(), label: "Business Head", value: "Business Head" },
    { id: nextId(), label: "PUC Coordinator", value: "PUC Coordinator" },
    {
      id: nextId(),
      label: "Nursery Coordinator",
      value: "Nursery Coordinator",
    },
    {
      id: nextId(),
      label: "Administrration officer",
      value: "Administrration officer",
    },
    { id: nextId(), label: "Document Writer", value: "Document Writer" },
    { id: nextId(), label: "Creative Writer", value: "Creative Writer" },
    {
      id: nextId(),
      label: "Chemical Associate Professor",
      value: "Chemical Associate Professor",
    },
    {
      id: nextId(),
      label: "Electrical Associate Professor",
      value: "Electrical Associate Professor",
    },
    {
      id: nextId(),
      label: "Computer Science Associate Professor",
      value: "Computer Science Associate Professor",
    },
    { id: nextId(), label: "Chemical Professor", value: "Chemical Professor" },
    {
      id: nextId(),
      label: "Electrical Professor",
      value: "Electrical Professor",
    },
    {
      id: nextId(),
      label: "Computer Science Professor",
      value: "Computer Science Professor",
    },
    { id: nextId(), label: "Head of School", value: "Head of School" },
    { id: nextId(), label: "EVS", value: "EVS" },
    { id: nextId(), label: "Student Counselor", value: "Student Counselor" },
    {
      id: nextId(),
      label: "Public Relation Executive",
      value: "Public Relation Executive",
    },
    {
      id: nextId(),
      label: "Pre Primary coordinator",
      value: "Pre Primary coordinator",
    },
    { id: nextId(), label: "Computer Science", value: "Computer Science" },
    {
      id: nextId(),
      label: "IIT Foundation - Physics",
      value: "IIT Foundation - Physics",
    },
    {
      id: nextId(),
      label: "IIT Foundation - Chemistry",
      value: "IIT Foundation - Chemistry",
    },
    {
      id: nextId(),
      label: "IIT Foundsation - Mathematics",
      value: "IIT Foundsation - Mathematics",
    },
    {
      id: nextId(),
      label: "IIT foundation - Biology",
      value: "IIT foundation - Biology",
    },
    { id: nextId(), label: "Economics", value: "Economics" },
    { id: nextId(), label: "Librian", value: "Librian" },
    { id: nextId(), label: "Civics", value: "Civics" },
    { id: nextId(), label: "Dean of Boarding", value: "Dean of Boarding" },
    { id: nextId(), label: "Dean", value: "Dean" },
    { id: nextId(), label: "Corporate Trainer", value: "Corporate Trainer" },
    { id: nextId(), label: "Botony", value: "Botony" },
    { id: nextId(), label: "English", value: "English" },
    { id: nextId(), label: "Maths", value: "Maths" },
  ],
  exp: [
    { id: nextId(), label: "Fresher", value: "Fresher" },
    { id: nextId(), label: "1 - 3 Years", value: "1 - 3 Years" },
    { id: nextId(), label: "4 - 6 Years", value: "4 - 6 Years" },
    { id: nextId(), label: "7 - 10 Years", value: "7 - 10 Years" },
    { id: nextId(), label: "10 - 15 Years", value: "10 - 15 Years" },
    { id: nextId(), label: "> 15 Years", value: "> 15 Years" },
  ],
  key_skills: [
    {
      id: nextId(),
      label: "Good verbal and written communication skills",
      value: "Good verbal and written communication skills",
    },
    { id: nextId(), label: "Leadership", value: "Leadership" },
    { id: nextId(), label: "Time management", value: "Time management" },
    { id: nextId(), label: "People skills", value: "People skills" },
    {
      id: nextId(),
      label: "Problem solving & troubleshooting",
      value: "Problem solving & troubleshooting",
    },
    { id: nextId(), label: "Critical thinking", value: "Critical thinking" },
    { id: nextId(), label: "Disciplined", value: "Disciplined" },
    {
      id: nextId(),
      label: "Ability to handle stress and pressure",
      value: "Ability to handle stress and pressure",
    },
  ],
};
